import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import {
  convertBefehl2FormDataToModel,
  convertModelToBefehl2FormData
} from './converters'
import Auftrag2_10Form from './Auftrag2_10Form'
import { useBefehlForm } from '../../../hooks'
import { BefehlFormWrapper, BefehlFormProps } from '../Generic'
import { Befehl2 } from '../../../models'
import { Befehl2FormData, createBefehl2FormValidationSchema } from './schema'
import { AuftragX_25Form, AuftragX_95Form } from '../Auftraege'

/**
 * Main form component for Befehl 2
 */
export default function Befehl2Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-2-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl2>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl2FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl2FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl2FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl2FormData) => {
      const updatedBefehl = convertBefehl2FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl2FormData>
      befehlKennung="2"
      title={t('befehle.2.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      {/* Auftrag 2.10 */}
      <Auftrag2_10Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-2-10`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />

      {/* Auftrag 2.25 */}
      <AuftragX_25Form
        befehlKennung="2"
        fieldNamePrefix="auftrag_2_25"
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-2-25`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />

      {/* Auftrag 2.95 */}
      <AuftragX_95Form
        befehlKennung="2"
        fieldNamePrefix="auftrag_2_95"
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-2-95`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
    </BefehlFormWrapper>
  )
}
